module.exports = __webpack_public_path__ + "static/media/logo.62e9ea7a.png";